import { FC } from "react";
import { CLTVDashboard } from "../components";
import "./CLTVAnalysisDashboard.scss";

const CLTVAnalysisDashboard: FC = () => {
  return (
    <div className="cltv-analysis-dashboard">
      <CLTVDashboard />
    </div>
  );
};

export default CLTVAnalysisDashboard;
